import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchBBClaimDetailsStarted = () => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_STARTED,
  };
};

export const fetchBBClaimDetailsSuccess = (claimDetails) => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_SUCCESS,
    claimDetails: claimDetails,
  };
};

export const fetchBBClaimDetailsFailed = (error) => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_FAILED,
    payload: error,
  };
};

export const resetBBClaimDetails = () => {
  return {
    type: actionTypes.RESET_BALANCE_BILLING_CLAIM_DETAILS,
  };
};
export const fetchBBClaimDetails = (claimId: number) => {
  return (dispatch) => {
    dispatch(fetchBBClaimDetailsStarted());
    axios
      .get(serverconfigs.fetchBBClaimDetailsUrl+`/${claimId}`)
      .then((response) => {
        console.log(
          `fetched claim details for claimId ${claimId} `,
          response.data
        );
        dispatch(fetchBBClaimDetailsSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchBBClaimDetailsFailed(error));
      });
  };
};
